import { useEffect, useRef } from 'react';

/**
 * The overlays open right now, oldest first: dialogs, confirmations, menus,
 * selects and pickers. A select opened inside a dialog is on top, and Escape
 * should close only it.
 */
const openOverlays = [];

/**
 * Closes an overlay with Escape — the one global listener CLAUDE.md allows,
 * attached only while the overlay is open and only acting when it is the top
 * one.
 *
 * An overlay stays in the stack while it is busy: it swallows Escape instead
 * of leaving, so the one underneath cannot be closed in the middle of a save.
 *
 * @param {boolean} isOpen
 * @param {() => void} onClose
 * @param {boolean} [disabled=false] - Open but must not close now, e.g. saving.
 */
export const useEscapeToClose = (isOpen, onClose, disabled = false) => {
  const latest = useRef({ onClose, disabled });
  latest.current = { onClose, disabled };

  useEffect(() => {
    if (!isOpen) return undefined;

    const self = {};
    openOverlays.push(self);

    const onKeyDown = (event) => {
      if (event.key !== 'Escape' || openOverlays[openOverlays.length - 1] !== self) return;
      if (!latest.current.disabled) latest.current.onClose();
    };
    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      const index = openOverlays.indexOf(self);
      if (index !== -1) openOverlays.splice(index, 1);
    };
  }, [isOpen]);
};
